
import { useState, useEffect } from 'react';
import { Invitation, UserProfile } from '../types';
import { InvitationService } from '../services/InvitationService';
import { User } from 'firebase/auth';

interface InvitationManagementProps {
    user: User | null;
    userProfile: UserProfile | null;
}

export const useInvitationManagement = ({ user, userProfile }: InvitationManagementProps) => {
    const [invitations, setInvitations] = useState<Invitation[]>([]);
    const [allInvitations, setAllInvitations] = useState<Invitation[]>([]);
    const [emailInvites, setEmailInvites] = useState<Invitation[]>([]);

    // 1. Invitation Listener (Strictly scoped to user's UID and Org)
    useEffect(() => {
        if (!user || !userProfile?.orgId) {
            setInvitations([]);
            return;
        }
        return InvitationService.listenToUserInvitations(user.uid, userProfile.orgId, setInvitations);
    }, [user, userProfile?.orgId]);

    // 2. All Pending Invitations (Strictly scoped to Org)
    useEffect(() => {
        if (!user || !userProfile?.orgId) {
            setAllInvitations([]);
            return;
        }
        return InvitationService.listenToAllOrgInvitations(userProfile.orgId, setAllInvitations);
    }, [user, userProfile?.orgId]);

    // 3. Listener for EMAIL invitations (matching current user email)
    useEffect(() => {
        if (!user?.email) {
            setEmailInvites([]);
            return;
        }
        return InvitationService.listenToEmailInvitations(user.email, setEmailInvites);
    }, [user?.email]);

    return {
        invitations,
        allInvitations,
        emailInvites
    };
};
